import { executeGet } from "@/services/lukita";

export default async function fetchAll({ slug }) {
  const response = await executeGet(`/projects/${slug}/transactions`);
  return response.json();
}
